var map = {
	"./dashboard-manufactures/ic-manufacture.svg": "0493",
	"./dashboard-manufactures/ic-median.svg": "0c25",
	"./dashboard-manufactures/ic-percent.svg": "d6dd",
	"./dashboard-manufactures/ic-tardiness.svg": "50cd",
	"./ic-area.svg": "de84",
	"./ic-arrow-down.svg": "15c8",
	"./ic-arrow-expand.svg": "cf13",
	"./ic-arrow-left-pagination.svg": "6cd6",
	"./ic-arrow-left.svg": "8534",
	"./ic-arrow-right-pagination.svg": "b68b",
	"./ic-arrow-right-small.svg": "0730",
	"./ic-arrow-right.svg": "0d38",
	"./ic-arrow-up.svg": "9a12",
	"./ic-box-packed.svg": "e416",
	"./ic-calendar.svg": "c498",
	"./ic-car-red.svg": "3fe6",
	"./ic-car.svg": "baa2",
	"./ic-check-on.svg": "2fe9",
	"./ic-city-area.svg": "4512",
	"./ic-city.svg": "1f89",
	"./ic-clear-thin.svg": "1abf",
	"./ic-clear.svg": "2108",
	"./ic-clock.svg": "497a",
	"./ic-close-2.svg": "0b13",
	"./ic-close-btn.svg": "b3b4",
	"./ic-close.svg": "c4c8",
	"./ic-courier-menu.svg": "7cc9",
	"./ic-courier-red.svg": "cf5b",
	"./ic-courier.svg": "b6e2",
	"./ic-delete.svg": "206a",
	"./ic-doc.svg": "b516",
	"./ic-download.svg": "9295",
	"./ic-edit-2.svg": "bf10",
	"./ic-edit.svg": "30e4",
	"./ic-encashment.svg": "4650",
	"./ic-exit.svg": "20d7",
	"./ic-gain-off.svg": "fce3e",
	"./ic-gain-on.svg": "3816",
	"./ic-global-settings.svg": "b45d",
	"./ic-late.svg": "cf6c",
	"./ic-loader.svg": "0ce2",
	"./ic-manufactures.svg": "5ad1",
	"./ic-manufature-active.svg": "5cb9",
	"./ic-map-pin.svg": "85ef",
	"./ic-menu-exit.svg": "2337",
	"./ic-menu.svg": "b79e",
	"./ic-minus.svg": "2c59",
	"./ic-monitoring.svg": "f7fd",
	"./ic-open-list.svg": "1a40",
	"./ic-order-collect.svg": "6792",
	"./ic-order.svg": "395a",
	"./ic-pause.svg": "4aa9",
	"./ic-plus.svg": "2a70",
	"./ic-print-color.svg": "c88e",
	"./ic-print.svg": "8efc",
	"./ic-refresh.svg": "116d",
	"./ic-regions.svg": "e3c1",
	"./ic-search.svg": "a5d6",
	"./ic-select.svg": "de5e",
	"./ic-settings.svg": "b097",
	"./ic-sort.svg": "3335",
	"./ic-status-disabled.svg": "94d8",
	"./ic-status-enabled.svg": "ef70",
	"./ic-status-not-available.svg": "34ae",
	"./ic-warning-2.svg": "b3ca",
	"./ic-warning.svg": "cc33",
	"./ic_bicycle-red.svg": "370b",
	"./ic_bicycle.svg": "762a",
	"./production-summary/ic-analisis.svg": "5a06",
	"./production-summary/ic-avg-check.svg": "5e5a",
	"./production-summary/ic-cash-amount.svg": "90d0",
	"./production-summary/ic-customers-white.svg": "de05",
	"./production-summary/ic-customers.svg": "1da7",
	"./production-summary/ic-delivery-white.svg": "60a5",
	"./production-summary/ic-delivery.svg": "ffde",
	"./production-summary/ic-orders.svg": "fe74",
	"./production-summary/ic-tardiness-white.svg": "590f",
	"./production-summary/ic-tardiness.svg": "eee7",
	"./shift-statuses/ic-delivery-status.svg": "e028",
	"./shift-statuses/ic-gain-status.svg": "dbbe",
	"./shift-statuses/ic-ontheway-status.svg": "38a4",
	"./shift-statuses/ic-pause-status.svg": "7c82",
	"./shift-statuses/ic-ready-status.svg": "4ac1",
	"./shift-statuses/ic-review-status.svg": "1936",
	"./shift-statuses/ic-wait_check_bags-status.svg": "10f4"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "4555";